import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getReviewsSummary } from "../lib/api";

const SITE = "https://zuerichairporttaxi.ch";

// Injects AggregateRating + Review JSON-LD (tied to the TaxiService entity) from
// real post-trip customer ratings. Renders nothing visually; skipped when no reviews.
export default function ReviewSchema() {
  const [s, setS] = useState(null);
  useEffect(() => { getReviewsSummary().then(setS).catch(() => setS(null)); }, []);
  if (!s || !s.count) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "TaxiService",
    "@id": `${SITE}/#taxiservice`,
    name: "Zuerich Airport Taxi",
    url: SITE,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: s.average,
      reviewCount: s.count,
      bestRating: 5,
      worstRating: 1,
    },
    review: (s.reviews || []).map((r) => ({
      "@type": "Review",
      author: { "@type": "Person", name: r.author || "Gast" },
      ...(r.date ? { datePublished: r.date } : {}),
      reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5, worstRating: 1 },
      ...(r.text ? { reviewBody: r.text } : {}),
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
